import { z } from 'zod';

export const ImageModelSchema = z.object({
    url: z.string(),
});

export type ImageModel = z.infer<typeof ImageModelSchema>;
